import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import {
	getSettingsResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../utils/helpers/settings";

export const useGroupingsFilter = () => {
	const { t } = useTranslation();
	return useMemo(
		() => ({
			id: "grouping",
			Header: t("groupings-worked"),
			canFilter: true,
			filter: "resource-select",
			Filter: (
				<ResourceSelect
					resourcePath="/grouping?pagination=off&excludedResources=pay-code"
					mode="multiple"
					renderLabel={renderSettingsResourceLabel}
					getSearchFilters={getSettingsResourceSearchFilters}
					hasSearch
				/>
			),
		}),
		[t],
	);
};
